package fr.frux.core.common.share

/**
 * Partage système d'un contenu (#391), sur le modèle exact de [fr.frux.core.common.directions.DirectionsLauncher] :
 * chaque plateforme a sa propre notion de « partager » (chooser Android, `UIActivityViewController`
 * iOS, `navigator.share` web), aucune API commune ne les couvre.
 *
 * Contrairement à `DirectionsLauncher.openDirections`, le résultat distingue le partage effectif
 * d'un repli « copié dans le presse-papiers » (web sans `navigator.share`, desktop) : l'appelant en
 * a besoin pour choisir le bon message de confirmation.
 */
interface ShareLauncher {
    /**
     * Propose de partager [text] suivi de [url], sous le titre [title] quand la plateforme le
     * permet. [text] ne contient jamais l'URL : chaque implémentation la joint à sa façon (ligne
     * finale du message, ou objet distinct quand la plateforme sait en faire un aperçu).
     */
    suspend fun share(
        title: String,
        text: String,
        url: String,
    ): ShareOutcome
}

/** Issue du geste de partage, distincte de [fr.frux.core.common.directions.DirectionsLauncher] car un repli existe. */
enum class ShareOutcome {
    /** Le chooser/la feuille système a été proposée à l'utilisateur. */
    SHARED,

    /** Pas de mécanisme de partage disponible : le contenu a été copié dans le presse-papiers. */
    COPIED,

    /** L'utilisateur a fermé le chooser sans choisir de destination. */
    CANCELLED,

    /** Ni partage ni repli n'ont fonctionné. */
    FAILED,
}

expect fun createShareLauncher(): ShareLauncher
